import { useState } from "react";
import EventComponent from "../components/EventComponent";
import Header from "../components/Header";



const EventPage = () => {

    const [events, setEvents] = useState([
        {
            title: `Génie Révolution`,
            desc: `Génie Révolution : 4 éditions de ce concours réalisés pour les écoliers et universitaires`,
            time: `09:00 AM`,
            year: ``,
            day: `01`,
            month: `Jul` ,
            location:`Juvenat, Hotel Caribe` ,
            img:``
        } ,

        {
            title: `Accompagnement des étudiants `,
            desc: ` Accompagnement des étudiants et récalés; orientation professionnelle (depuis 6 ans).`,
            time: `09:00 AM`,
            year: ``,
            day: `01`,
            month: `Jul`,
            location: `Juvenat, Hotel Caribe` ,
            img: ``

        },
        {
            title: `It's not over for you`,
            desc: `Formation en leadership organisée par SAFA Systems en collaboration avec ONFEJ`,
            time: `09:00 AM`,
            year: `2023`,
            day: `15`,
            month: `Jul`,
            location: `Pétion-ville, Hotel Kinam` ,
            img: ``,
        },
        {
            title: `Unlimited opportunities`,
            desc: `Formation en leadership organisée par SAFA Systems en collaboration avec ONFEJ`,
            time: `09:00 AM`,
            year: `2023`,
            day: `15`,
            month: `Agu`,
            location: `Juvenat, Hotel Karibe`,
            img: ``,
        },
        {
            title: `Formation en leadership, ONFEJ à CANADA 2015 `,
            desc: `Formation en leadership organisée par SAFA Systems en collaboration avec ONFEJ`,
            time: `09:00 AM`,
            year: `2023`,
            day: `15`,
            month: `Agu`,
            location: `Juvenat, Hotel Karibe`,
            img: ``,
        },
       
    ])

    return (
        <>
            <Header type="event" />

            <section className="lg:w-[80%] md:w-[90%] sm:w-full m-auto  ">
                <h1 className="text-4xl text-start font-bold py-6 mt-3 px-5">Our events</h1>
                <div className="mb-10 h-[2px] w-[15%] bg-orange-500 ml-5"></div>
                {events?.map((e, i) => (
                    <EventComponent key={i} index={i} event={e} />
                ))}
            </section>
        </>
    )
}

export default EventPage;